import {Authenticated} from 'src/router/middlewares'

export default [
    {
        path: '/referrals',
        name: 'referrals.index',
        component: () => import('src/pages/referrals/index'),
        meta: {
            title: 'Referrals',
            middleware: [Authenticated]
        }
    },
    {
        path: '/referrals/codes',
        name: 'referrals.codes',
        component: () => import('src/pages/referrals/codes'),
        meta: {
            title: 'Referrals',
            middleware: [Authenticated]
        }
    }
]
